import axios from "axios";
const jsonConfig = require("../../Config.json");

const getAllReferralpartnersbyskillid = async (id) => {
  try {
    const getAllResponse = await axios.get(jsonConfig.apiUrl + "referralpartnersbyskillid/" +id, {
      headers: {
        "x-functions-key": jsonConfig.key,
      },
    });

    return Promise.resolve(getAllResponse);
  } catch (error) {
    return Promise.reject(error);
  }
};
export default getAllReferralpartnersbyskillid;
